<div class="container">
    <p class="fs-4 text-center" *ngIf="listName && listLength > 0">
        {{ 'no-contact-modal.title' | translate: {count: listLength, list: listName} }}
    </p>
    <div class="d-flex gap-2 mt-4">
        <button class="btn btn-block btn-outlined btn-green btn-rounded" (click)="close(false)">{{ 'NON'|translate }}</button>
        <button class="btn btn-block btn-green btn-rounded" (click)="close(true)">{{ 'OUI'|translate }}</button>
    </div>
</div>
